import React from 'react'

import EditBrandForm from '../../modules/Brand/components/EditBrandForm'
export default function EditBrandPage() {
  return <EditBrandForm />
}
